import CardWrapper from './CardWrapper.component';

export default CardWrapper;
